
var __extends = this.__extends || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    __.prototype = b.prototype;
    d.prototype = new __();
};
define('core/node_eventemitter',["require", "exports", './buffer', './api_error'], function(require, exports, buffer, api_error) {
    var Buffer = buffer.Buffer;
    var ApiError = api_error.ApiError;
    var ErrorCode = api_error.ErrorCode;

    /**
    * Internal class. Represents a buffered event.
    */
    var BufferedEvent = (function () {
        function BufferedEvent(data, encoding, cb) {
            this.data = data;
            this.encoding = encoding;
            this.cb = cb;
            this.size = typeof (data) !== 'string' ? data.length : Buffer.byteLength(data, encoding != null ? encoding : undefined);

            // If data is a buffer, we need to copy it.
            if (typeof (this.data) !== 'string') {
                this.data = this.data.sliceCopy();
            }
        }
        BufferedEvent.prototype.getData = function (encoding) {
            if (encoding == null) {
                if (typeof (this.data) === 'string') {
                    return new Buffer(this.data, this.encoding != null ? this.encoding : undefined);
                } else {
                    return this.data;
                }
            } else {
                if (typeof (this.data) === 'string') {
                    if (encoding === this.encoding) {
                        return this.data;
                    } else {
                        return (new Buffer(this.data, this.encoding != null ? this.encoding : undefined)).toString(encoding);
                    }
                } else {
                    return this.data.toString(encoding);
                }
            }
        };
        return BufferedEvent;
    })();

    /**
    * Provides an abstract implementation of the EventEmitter interface.
    */
    var AbstractEventEmitter = (function () {
        function AbstractEventEmitter() {
            this._listeners = {};
            this.maxListeners = 10;
        }
        /**
        * Adds a listener for the particular event.
        */
        AbstractEventEmitter.prototype.addListener = function (event, listener) {
            if (typeof (this._listeners[event]) === 'undefined') {
                this._listeners[event] = [];
            }
            if (this._listeners[event].push(listener) > this.maxListeners) {
                process.stdout.write("Warning: Event " + event + " has more than " + this.maxListeners + " listeners.\n");
            }
            this.emit('newListener', event, listener);
            return this;
        };

        /**
        * Adds a listener for the particular event.
        */
        AbstractEventEmitter.prototype.on = function (event, listener) {
            return this.addListener(event, listener);
        };

        /**
        * Adds a listener for the particular event that fires only once.
        */
        AbstractEventEmitter.prototype.once = function (event, listener) {
            // Create a new callback that will only fire once.
            var fired = false, newListener = function () {
                this.removeListener(event, newListener);

                if (!fired) {
                    fired = true;
                    listener.apply(this, arguments);
                }
            };
            return this.addListener(event, newListener);
        };

        /**
        * Emits the 'removeListener' event for the specified listeners.
        */
        AbstractEventEmitter.prototype._emitRemoveListener = function (event, listeners) {
            var i;

            // Only emit the event if someone is listening.
            if (this._listeners['removeListener'] && this._listeners['removeListener'].length > 0) {
                for (i = 0; i < listeners.length; i++) {
                    this.emit('removeListener', event, listeners[i]);
                }
            }
        };

        /**
        * Removes the particular listener for the given event.
        */
        AbstractEventEmitter.prototype.removeListener = function (event, listener) {
            var listeners = this._listeners[event];
            if (typeof (listeners) !== 'undefined') {
                // Remove listener, if present.
                var idx = listeners.indexOf(listener);
                if (idx > -1) {
                    listeners.splice(idx, 1);
                }
            }
            this.emit('removeListener', event, listener);
            return this;
        };

        /**
        * Removes all listeners, or those of the specified event.
        */
        AbstractEventEmitter.prototype.removeAllListeners = function (event) {
            var removed, keys, i;
            if (typeof (event) !== 'undefined') {
                removed = this._listeners[event];

                // Clear one event.
                this._listeners[event] = [];
                this._emitRemoveListener(event, removed);
            } else {
                // Clear all events.
                keys = Object.keys(this._listeners);
                for (i = 0; i < keys.length; i++) {
                    this.removeAllListeners(keys[i]);
                }
            }
            return this;
        };

        /**
        * EventEmitters print a warning when an event has greater than this specified
        * number of listeners.
        */
        AbstractEventEmitter.prototype.setMaxListeners = function (n) {
            this.maxListeners = n;
        };

        /**
        * Returns the listeners for the given event.
        */
        AbstractEventEmitter.prototype.listeners = function (event) {
            if (typeof (this._listeners[event]) === 'undefined') {
                this._listeners[event] = [];
            }

            // Return a *copy* of our internal structure.
            return this._listeners[event].slice(0);
        };

        /**
        * Emits the specified event to all listeners of the particular event.
        */
        AbstractEventEmitter.prototype.emit = function (event) {
            var args = [];
            for (var _i = 0; _i < (arguments.length - 1); _i++) {
                args[_i] = arguments[_i + 1];
            }
            var listeners = this._listeners[event], rv = false;
            if (typeof (listeners) !== 'undefined') {
                var i;
                for (i = 0; i < listeners.length; i++) {
                    rv = true;
                    listeners[i].apply(this, args);
                }
            }
            return rv;
        };
        return AbstractEventEmitter;
    })();
    exports.AbstractEventEmitter = AbstractEventEmitter;

    /**
    * Provides an abstract implementation of the WritableStream and ReadableStream
    * interfaces.
    * @todo: Check readable/writable status.
    */
    var AbstractDuplexStream = (function (_super) {
        __extends(AbstractDuplexStream, _super);
        /**
        * Abstract stream implementation that can be configured to be readable and/or
        * writable.
        */
        function AbstractDuplexStream(writable, readable) {
            _super.call(this);
            this.writable = writable;
            this.readable = readable;
            /**
            * How should the data output be encoded? 'null' means 'Buffer'.
            */
            this.encoding = null;
            /**
            * Is this stream currently flowing (resumed) or non-flowing (paused)?
            */
            this.flowing = false;
            /**
            * Event buffer. Simply queues up all write requests.
            */
            this.buffer = [];
            /**
            * Once set, the stream is closed. Emitted once 'buffer' is empty.
            */
            this.endEvent = null;
            /**
            * Has the stream ended?
            */
            this.ended = false;
            /**
            * The last time we checked, was the buffer empty?
            * We emit 'readable' events when this transitions from 'true' -> 'false'.
            */
            this.drained = true;
        }
        /**
        * Adds a listener for the particular event.
        * Implemented here so that we can capture data EventListeners, which trigger
        * us to 'resume'.
        */
        AbstractDuplexStream.prototype.addListener = function (event, listener) {
            var rv = _super.prototype.addListener.call(this, event, listener), _this = this;
            if (event === 'data' && !this.flowing) {
                this.resume();
            } else if (event === 'readable' && this.buffer.length > 0) {
                setTimeout(function () {
                    _this.emit('readable');
                }, 0);
            }
            return rv;
        };

        /**
        * Helper function for 'write' and 'end' functions.
        */
        AbstractDuplexStream.prototype._processArgs = function (data, arg2, arg3) {
            if (typeof (arg2) === 'string') {
                // data, encoding, cb?
                return new BufferedEvent(data, arg2, arg3);
            } else {
                // data, cb?
                return new BufferedEvent(data, null, arg2);
            }
        };

        /**
        * If flowing, this will process pending events.
        */
        AbstractDuplexStream.prototype._processEvents = function () {
            var drained = this.buffer.length === 0;
            if (this.drained !== drained) {
                if (this.drained) {
                    // Went from drained to not drained. New stuff is available.
                    // @todo: Is this event relevant in flowing mode?
                    this.emit('readable');
                }
            }

            if (this.flowing && this.buffer.length !== 0) {
                this.emit('data', this.read());
            }

            // Are we drained? Check.
            this.drained = this.buffer.length === 0;
        };

        /**
        * Emits the given buffered event.
        */
        AbstractDuplexStream.prototype.emitEvent = function (type, event) {
            this.emit(type, event.getData(this.encoding));
            if (event.cb) {
                event.cb();
            }
        };

        AbstractDuplexStream.prototype.write = function (data, arg2, arg3) {
            if (this.ended) {
                throw new ApiError(0 /* EPERM */, 'Cannot write to an ended stream.');
            }
            var event = this._processArgs(data, arg2, arg3);
            this._push(event);
            return this.flowing;
        };

        AbstractDuplexStream.prototype.end = function (data, arg2, arg3) {
            if (this.ended) {
                throw new ApiError(0 /* EPERM */, 'Stream is already closed.');
            }
            var event = this._processArgs(data, arg2, arg3);
            this.ended = true;
            this.endEvent = event;
            this._processEvents();
        };

        /**** Readable Interface ****/
        /**
        * Read a given number of bytes from the buffer. Should only be called in
        * non-flowing mode.
        * If we do not have `size` bytes available, return null.
        */
        AbstractDuplexStream.prototype.read = function (size) {
            var events = [], eventsCbs = [], lastCb, eventsSize = 0, event, buff, trueSize, i = 0, sizeUnspecified = typeof (size) !== 'number';

            // I do this so I do not need to specialize the loop below.
            if (sizeUnspecified)
                size = 4294967295;

            for (i = 0; i < this.buffer.length && eventsSize < size; i++) {
                event = this.buffer[i];
                events.push(event.getData());
                if (event.cb) {
                    eventsCbs.push(event.cb);
                }
                eventsSize += event.size;
                lastCb = event.cb;
            }

            if (!sizeUnspecified && eventsSize < size) {
                // For some reason, the Node stream API specifies that we either return
                // 'size' bytes of data, or nothing at all.
                return null;
            }

            // Remove all of the events we are processing from the buffer.
            this.buffer = this.buffer.slice(events.length);

            // The 'true size' of the final event we're going to send out.
            trueSize = eventsSize > size ? size : eventsSize;

            // Concat at all of the events into one buffer.
            buff = Buffer.concat(events);
            if (eventsSize > size) {
                // If last event had a cb, ignore it -- we trigger it when that *entire*
                // write finishes.
                if (lastCb)
                    eventsCbs.pop();

                // Make a new event for the remaining data.
                this._push(new BufferedEvent(buff.slice(size), null, lastCb));
            }

            // Schedule the relevant cbs to fire *after* we've returned these values.
            if (eventsCbs.length > 0) {
                setTimeout(function () {
                    var i;
                    for (i = 0; i < eventsCbs.length; i++) {
                        eventsCbs[i]();
                    }
                }, 0);
            }

            // If we're at the end of the buffer and an endEvent is specified, schedule
            // the event to fire.
            if (this.ended && this.buffer.length === 0 && this.endEvent !== null) {
                var endEvent = this.endEvent, _this = this;

                // Erase it so we don't accidentally trigger it again.
                this.endEvent = null;
                setTimeout(function () {
                    _this.emitEvent('end', endEvent);
                }, 0);
            }

            // Return in correct encoding.
            if (events.length === 0) {
                // Buffer was empty. We're supposed to return 'null', as opposed to an
                // empty buffer or string.
                // [BFS] Emit a '_read' event to signal that maybe the write-end of this
                //       should push some data into the pipe.
                this.emit('_read');
                return null;
            } else if (this.encoding === null) {
                return buff.slice(0, trueSize);
            } else {
                return buff.toString(this.encoding, 0, trueSize);
            }
        };

        /**
        * Set the encoding for the 'data' event.
        */
        AbstractDuplexStream.prototype.setEncoding = function (encoding) {
            this.encoding = encoding;
        };

        /**
        * Pause the stream.
        */
        AbstractDuplexStream.prototype.pause = function () {
            this.flowing = false;
        };

        /**
        * Resume the stream.
        */
        AbstractDuplexStream.prototype.resume = function () {
            this.flowing = true;

            // Process any buffered writes.
            this._processEvents();
        };

        /**
        * Pipe a readable stream into a writable stream. Currently unimplemented.
        */
        AbstractDuplexStream.prototype.pipe = function (destination, options) {
            throw new ApiError(0 /* EPERM */, "Unimplemented.");
        };
        AbstractDuplexStream.prototype.unpipe = function (destination) {
        };

        AbstractDuplexStream.prototype.unshift = function (chunk) {
            if (this.ended) {
                throw new ApiError(0 /* EPERM */, "Stream has ended.");
            }
            this.buffer.unshift(new BufferedEvent(chunk, this.encoding));
            this._processEvents();
        };

        /**
        * 'Push' the given piece of data to the back of the buffer.
        * Returns true if the event was sent out, false if buffered.
        */
        AbstractDuplexStream.prototype._push = function (event) {
            this.buffer.push(event);
            this._processEvents();
        };

        /**
        * Enables backwards-compatibility with older versions of Node and their
        * stream interface. Unimplemented.
        */
        AbstractDuplexStream.prototype.wrap = function (stream) {
            throw new ApiError(0 /* EPERM */, "Unimplemented.");
        };
        return AbstractDuplexStream;
    })(AbstractEventEmitter);
    exports.AbstractDuplexStream = AbstractDuplexStream;
});
//# sourceMappingURL=node_eventemitter.js.map
;